var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPowerOff2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5377_12796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 1.69062C14.4687 3.09687 15.7499 5.39687 15.7499 8C15.7499 12.275 12.2874 15.7406 8.01557 15.75C3.74994 15.7594 0.256195 12.2812 0.249945 8.0125C0.24682 5.40937 1.52807 3.10313 3.49369 1.69375C3.85932 1.43438 4.36869 1.54375 4.58744 1.93438L5.08119 2.8125C5.26557 3.14062 5.17807 3.55625 4.87494 3.78125C3.57807 4.74375 2.74994 6.26875 2.74994 7.99687C2.74682 10.8813 5.07807 13.25 7.99994 13.25C10.8624 13.25 13.2687 10.9312 13.2499 7.96562C13.2406 6.34687 12.4781 4.78438 11.1218 3.77813C10.8187 3.55313 10.7343 3.1375 10.9187 2.8125L11.4124 1.93438C11.6312 1.54688 12.1374 1.43125 12.4999 1.69062ZM9.24994 8.25V0.75C9.24994 0.334375 8.91557 0 8.49994 0H7.49994C7.08432 0 6.74994 0.334375 6.74994 0.75V8.25C6.74994 8.66562 7.08432 9 7.49994 9H8.49994C8.91557 9 9.24994 8.66562 9.24994 8.25Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5377_12796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPowerOff2);
export default __webpack_public_path__ + "static/media/ic_power_off2.e120913c3772036d207de8804e4475f0.svg";
export { ForwardRef as ReactComponent };